/**
 * Resolve a user-typed order-number filter value to its numeric form.
 *
 * Trims surrounding whitespace and strips an optional case-insensitive
 * "<prefix>-" (e.g. parseOrderNumber( 'REQ-123', 'REQ' ) === 123). Returns
 * undefined when the remaining text is not a positive integer, so callers can
 * treat undefined as "nothing valid to look up".
 *
 * Used by the DC Admin Fulfillment Orders filters so FO-, REQ-, and TO- can be
 * pasted in directly, mirroring the main Requests table behavior.
 */
export default function parseOrderNumber( input: string, prefix: string ): number | undefined {
	const trimmed = input.trim()
	const withoutPrefix = trimmed.toUpperCase().startsWith( `${prefix.toUpperCase()}-` )
		? trimmed.slice( prefix.length + 1 )
		: trimmed

	if ( !/^\d+$/.test( withoutPrefix ) ) {
		return undefined
	}

	return Number( withoutPrefix )
}
